<template>
  <transition name="modal">
    <div id="modalSoumettre" class="modal-wrapper">
      <b-card class="modal-container">

        <h3 class="mt-3 mb-3">Soumettre un fichier de justification</h3>

        <ul>
          <li>
            Formats de fichier pris en charge : .csv
          </li>
          <li>
            Exemple de fichier valide : <div class="eyeValide">
            <i class="fas fa-eye"></i><div class="pattern"><img src='@/assets/pattern.png' width="70%"></div></div>
            (En jaune les 3 colonnes et entêtes obligatoires)
          </li>
          <li class="important">
          Renseigner obligatoirement le champ type
          </li>
          <li class="important">
          Renseigner obligatoirement le champ justification_text si type=justification
          </li>
        </ul>

        <div class="mt-3 mb-3" >Fichier
          <input type="file" ref="uploadFile" accept=".csv" @change="handleFileUpload()"/>
        </div>
        <b-button pill @click="submitFile" class="nav-link3 m-2">Valider</b-button>
        <b-button pill class="nav-link2 m-2" id="close" @click="$emit('close')">Annuler</b-button>

      </b-card>

    </div>
  </transition>
</template>

<script>
import { ref } from 'vue';
import axios from "axios";
import config from "../../config";
import eventBus from '@/eventBus.js';

export default {
  name: 'SubmitFileModal',

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props, { emit }) {
    const formData = ref(null);
    const uploadFile = ref(null);
    const toastMessage = ref("");
    const showNotification = ref(false);
    const toastType = ref("info");
    const duration = ref(5000);

    const handleFileUpload = () => {
      const file = uploadFile.value.files[0];
      formData.value = new FormData();
      formData.value.append('file', file);
    };

    const submitFile = async () => {
      if (!formData.value || !formData.value.has('file')) {
        // Si aucun fichier n'est sélectionné, afficher un message d'erreur
        emit('notification', {
          showNotification : true,
          toastMessage: 'Veuillez sélectionner un fichier avant de soumettre.',
          toastType: 'danger'
        });
        return; // Stopper l'exécution si aucun fichier n'est présent
      }
        emit('notification', {
          showNotification : true,
          toastMessage: 'Le fichier est en cours d\'analyse, veuillez patienter',
          toastType: 'success'
        });

        try {
          await axios.post(`${config.API_URL}justification/submitInBdd/`, formData.value, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'multipart/form-data'
            }
          });
          eventBus.emit('reloadRapport');
          emit('close');
          emit('notification', {
            showNotification : true,
            toastMessage: 'Le fichier a bien été soumis',
            toastType: 'success'
          });
        } catch (error) {
          emit('notification', {
            showNotification : true,
            toastMessage: 'Une erreur est survenue, veuillez vérifier votre fichier.',
            toastType: 'danger'
          });
        }
    };

    return {
      handleFileUpload,
      submitFile,
      uploadFile,
      toastMessage,
      showNotification,
      toastType,
      duration
    };
  }
};
</script>

<style>
.important{
  color: darkorange;
}
.pattern{
  display: none;
}
.eyeValide:hover .pattern{
display: block;
}

</style>